<template>
    <v-app id="inspire">
        <v-main>
            <v-container class="fill-height" fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12" md="4">
                        <img
                            width="100%;"
                            src="https://fidiaspro.com/wp-content/uploads/2022/03/Logo-Fidias-Pro-sin-fondo-Negro-e1646664499686.png"
                            alt=""
                        />

                        <v-card
                            style="border-radius: 0"
                            flat
                            class="elevation-2"
                        >
                            <v-card-text>
                                <v-form>
                                    <v-text-field
                                        prepend-icon="mdi-account"
                                        v-model="user.email"
                                        label="Email"
                                        required
                                    ></v-text-field>
                                    <v-text-field
                                        prepend-icon="mdi-key"
                                        v-model="user.password"
                                        label="Contraseña"
                                        required
                                        type="password"
                                    ></v-text-field>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <router-link to="/forgot">
                                    Olvidé Contraseña
                                </router-link>
                                <v-spacer></v-spacer>

                                <v-btn
                                    :disabled="isloading"
                                    @click="Login"
                                    class="white--text login-button"
                                    :loading="isloading"
                                    >Login</v-btn
                                >
                            </v-card-actions>
                            <v-spacer></v-spacer>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import auth from "../../auth/auth.js";
export default {
    data() {
        return {
            user: {
                email: "",
                password: "",
            },
        };
    },
    mounted() {
        if (localStorage != undefined) {
            let valid = localStorage.user_id;
            if (valid) {
                window.location.href = "/";
            }
        }
    },
    methods: {
        Login() {
            // Pasar la referencia del toast al método de autenticación
            auth.signin(this.user, this.$toast);
        },
    },
    computed: {
        isloading: function () {
            return this.$store.getters.getloading;
        },
    },
};
</script>

<style>
.cover-img {
    height: 100%;
}

.back {
    background-color: #212121;
}

/* Estilos corporativos SOLO para el botón de login */
.login-button {
    background-color: #000000 !important;
    border: 2px solid #000000 !important;
    font-weight: bold !important;
    font-size: 16px !important;
    padding: 12px 32px !important;
    border-radius: 4px !important;
    text-transform: uppercase !important;
    letter-spacing: 0.5px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
    transition: all 0.3s ease !important;
}

.login-button:hover {
    background-color: #333333 !important;
    border-color: #333333 !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4) !important;
}

.login-button:focus {
    background-color: #000000 !important;
    border-color: #000000 !important;
    outline: none !important;
}

.login-button:active {
    transform: translateY(0px) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
}
</style>
